import Hero from 'flarum/forum/components/Hero';
import ItemList from 'flarum/common/utils/ItemList';
export default class ContactHero extends Hero {
  className() {
    return 'ContactPage-hero';
  }
  bodyItems() {
    const items = new ItemList();
    items.add('title', m("h1", {
      className: "ContactPage-heroTitle"
    }, this.attrs.title), 100);
    if (this.attrs.description) {
      items.add('description', m("p", {
        className: "ContactPage-heroDescription"
      }, this.attrs.description), 90);
    }
    return items;
  }
}
flarum.reg.add('cengizkemec-contact-page', 'forum/components/ContactHero', ContactHero);